import { useQuery } from "@jti/rest-api";

import { getCurrentMagentoClient } from "../clients/getClient";
import type { IGetCustomerOrderDetailsQuery } from "../types/CodegenTypes";
import { IScopeTypeEnum } from "../types/CodegenTypes";

type UseOrderDetails = {
  order: any;
  isValid: boolean;
  isLoadingOrderDetails: boolean;
};

const fetchCustomerOrderDetails = async (orderId: string, isTrial: boolean) => {
  const magentoClient = getCurrentMagentoClient(isTrial);

  return magentoClient
    .getCustomerOrderDetails(orderId, IScopeTypeEnum.Global)
    .catch(() => magentoClient.getCustomerExportOrderDetails(orderId));
};

export const useOrderDetails = (orderId: string, isTrial: boolean): UseOrderDetails => {
  const queryKey = isTrial ? "getFreeTrialCustomerOrderDetails" : "getCustomerOrderDetails";

  const { data, isError, isLoading } = useQuery({
    queryKey: `${queryKey}_${orderId}`,
    queryFn: () => fetchCustomerOrderDetails(orderId, isTrial),
    select: (data: IGetCustomerOrderDetailsQuery) => data.customer.orders.items[0],
  });

  return {
    order: data,
    isValid: !isError && !!data && Object.keys(data).length > 0,
    isLoadingOrderDetails: isLoading,
  };
};
